var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 74,
    viewBox: "0 0 133 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2633_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.548 48C123.63 48 128.507 43.0822 128.507 37C128.507 30.9178 123.63 26.0411 117.548 26.0411C111.466 26.0411 106.589 30.9589 106.589 37C106.603 43.0274 111.521 48 117.548 48ZM102.616 22.0548H132.534V51.9726H102.616V22.0548Z",
    fill: "#1F774D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9452 41.5343C57.1918 45.3425 53.3836 48 48.9315 48C43.0274 48 38.1918 43.2877 37.9726 37.4247H63.9041V22.0548H34V51.9726H63.9178V41.5343H58.9452ZM38.4521 33.7397H59.3425C57.8082 28.6438 53.6986 26.0411 48.9452 26.0411C44.1918 26.0411 39.7671 28.8219 38.4521 33.7397Z",
    fill: "#1F774D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9726 22.0548H0.0548096V51.9726H29.9726V41.5343H25.0137C23.3014 45.3425 19.4521 48 15.0411 48C8.95892 48 4.04111 43.0411 4.04111 37C4.04111 30.9589 8.95892 26.0411 15.0411 26.0411C19.5343 26.0411 23.3836 28.7808 25.0959 32.6712H29.9726V22.0548Z",
    fill: "#1F774D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8767 41.5343H93.9178C92.4247 45.4658 88.3973 47.9589 83.822 47.9589C77.9178 47.9589 72.9452 43.6849 72.9452 37V22.0548H67.8904V51.9726H98.8767V41.5343Z",
    fill: "#1F774D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2633_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.603,
    height: 30,
    fill: "white",
    transform: "translate(0 22)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelo);
export default __webpack_public_path__ + "static/media/celo.4945a7f106381ffc80c382225f3a3c78.svg";
export { ForwardRef as ReactComponent };